/**
 * Lista de Tematicas ambientales
 */
import { LISTA_TEMATICAS } from "../data/tematicas.data";
const Tematicas = {
  getList: function() {
    return LISTA_TEMATICAS;
  }
};
export default Tematicas;
